export default function getAllowedPurchaseYears(yearImm) {
  const minYear = yearImm;
  const maxYear = new Date().getFullYear();
  const y = [];
  for (let i = maxYear; i >= minYear; i--) {
    y.push({ id: i, name: i, value: i });
  }
  return y;
}
